var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAudioPlayButtonFilledShadow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    enableBackground: "new 0 0 66 66"
  },
  viewBox: "0 0 66 66"
}, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
  id: "icon-audio-play-button-filled-shadow_svg__a",
  width: "166.7%",
  height: "166.7%",
  x: "-33.3%",
  y: "-22.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 5,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.921568627 0 0 0 0.285778986 0"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  style: {
    filter: "url(#icon-audio-play-button-filled-shadow_svg__a)"
  },
  transform: "translate(9 4)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  style: {
    fill: "#0000eb"
  },
  transform: "translate(9 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.2 28-9.7 6.5v-13z",
  style: {
    fill: "#fff"
  }
}));
export default SvgIconAudioPlayButtonFilledShadow;